export type AlertSeverity = 'critical' | 'warning'

export type AlertEntityType =
  | 'enterprise'
  | 'site'
  | 'operating_area'
  | 'documents'
  | 'system'
  | 'component'
  | 'operation_unit'
  | 'functional_location'

export interface AlertItem {
  id: string
  entity: string
  description: string
  severity: AlertSeverity
  entityType: AlertEntityType
  /** Matching node id in the graph (optional — set when the alert maps to a node) */
  nodeId?: string
}

export const MOCK_ALERTS: AlertItem[] = [
  {
    id: 'alert-e-100-spi',
    entity: 'E-100 SPI',
    description:
      'Coolant supply issue detected: Temperature rose by 8°F in the last 2 weeks, potentially leading to overheating and equipment failure.',
    severity: 'critical',
    entityType: 'component',
  },
  {
    id: 'alert-e-100-sp',
    entity: 'E-100 SP',
    description: 'Approach temp widened 8°F in 2 weeks',
    severity: 'warning',
    entityType: 'component',
  },
  {
    id: 'alert-reflux-pump-p-100',
    entity: 'Reflux Pump P-100',
    description: 'Valve position drifting at same flow',
    severity: 'warning',
    entityType: 'component',
    nodeId: 'comp-p-100',
  },
  {
    id: 'alert-controller-fic-100',
    entity: 'Controller FIC-100',
    description: 'Flow at 2,550 bpm, lOW max 2,600',
    severity: 'warning',
    entityType: 'component',
  },
]
